import * as RootUtils from '../../utils'
import * as Types from './types'

interface File {
  lastModified: number,
  lastModifiedDate: any,
  name: string,
  size: number,
  type: string,
  webKitRelativePath: string,
}

export const validateImage = (file: File): boolean => {

  let isValid = false
  if (file) {

    const keyType = 'type'
    const fileType = file[keyType]
    const ValidImageTypes = ['image/gif', 'image/jpeg', 'image/png']
    if (ValidImageTypes.includes(fileType)) {
      isValid = true
    }
  }
  return isValid
}

export const asImageData = (name: string, content: any): Types.ModalImageData => {
  return {
    content,
    name,
    partnerCode: null,
    rowId: null,
  }
}

export const handleImageSelection = (communityName: string, files: any, uploadAction: any) => {
  if (files && files.length) {
    const file = files[0];
    const filename = file.name;
    const reader = new FileReader();
    reader.onload = (onloadArgs: any) => {
      const data = RootUtils.arrayBufferToString(onloadArgs.target.result);
      const fileContent = window.btoa(data);
      uploadAction(communityName, asImageData(filename, fileContent));
    }
    reader.readAsArrayBuffer(file)
  }
}



// WEBPACK FOOTER //
// ./src/components/image/utils.ts